import { render } from "./PatnersView.vue?vue&type=template&id=7925316c"
import script from "./PatnersView.vue?vue&type=script&lang=js"
export * from "./PatnersView.vue?vue&type=script&lang=js"

import "./PatnersView.vue?vue&type=style&index=0&id=7925316c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__